/* eslint-disable prefer-template */
/* eslint-disable default-param-last */
import { actionType } from 'Config/actionTypes';

const INITIAL_STATE = {
  data: [],
  isLoading: false,
  isError: false,
  responseTime: 0,
  msgError: '',
};
export const attritionsOverviewByEmployeeReducer = (
  state = INITIAL_STATE,
  action
) => {
  switch (action.type) {
    case actionType.ATTRITIONS_OVERVIEW_BY_EMPLOYEE + '_LOADING':
      return {
        ...state,
        isLoading: true,
      };
    case actionType.ATTRITIONS_OVERVIEW_BY_EMPLOYEE + '_RESULT':
      return {
        ...state,
        data: action.result.data,
        responseTime: action.result.responseTime,
        isLoading: false,
        isError: false,
        msgError: '',
      };
    case actionType.ATTRITIONS_OVERVIEW_BY_EMPLOYEE + '_FAILED':
      return {
        ...state,
        isError: true,
        msgError: action.err,
        isLoading: false,
      };
    case actionType.ATTRITIONS_OVERVIEW_BY_EMPLOYEE + '_ERROR':
      return {
        ...state,
        isLoading: false,
        isError: true,
        msgError: action.err,
        status: action.status
      }
    default:
      return state;
  }
};
